import {array, number, object} from "yup";
import {isOfficeGroup, officeGroup, offices} from "../../../../../@signals";

export const europcarPricingEnvironmentSchema = object({
    bookingWeek: array().min(1, "Must select a booking week"),
    pickupDate: array().min(1, "Must select a pickup date"),
    officePickupID: array()
        .test("isOfficePickupID", "Must select a pickup office", () => isOfficeGroup.value || !!offices.value?.length).nullable(),
    officeGroupID: array().test("isOfficeGroupID", "Must select an Office Group", () => !isOfficeGroup.value || !!officeGroup.value?.length).nullable(),
    providerID: array().min(1, "Must select a provider"),
    lor: number().required("Must select a rental length"),
    currency: number().required("Must select a currency"),
})